import React from 'react'
import ConnectVehicleCard, { Props } from './ConnectVehicleCard'

export default (props: Props) => <ConnectVehicleCard {...props} />
